var _a;
import { riskLevels } from 'constants/ehrNoteEnums';
export var riskTooltipRenderOptions = (_a = {
        default: { bg: 'platform.dark' }
    },
    _a[riskLevels.medium] = { bg: 'tertiary3.dark' },
    _a[riskLevels.high] = { bg: 'error.dark' },
    _a);
